import axios from "axios";

export const linkPickupRequestTransaction = (
  requestNumber: string,
  transactionNumber: string
): Promise<void> =>
  axios
    .post(`pickupRequests/${requestNumber}/linkTransaction`, {
      transactionNumber,
    })
    .then(() => undefined);

export default linkPickupRequestTransaction;
